import React from "react";
import confetti from "canvas-confetti";
import { Unlock, Rocket, Sparkles, ArrowRight } from "lucide-react";
import api from "../lib/api";

export default function ModoLiveUnlockModal({ isOpen, onClose, onUnlocked }) {
  if (!isOpen) return null;

  const handleUnlock = async () => {
    try {
      await api.post("/api/caverna/unlock-live");
      confetti({
        particleCount: 120,
        spread: 100,
        origin: { y: 0.5 },
        colors: ["#FF6B00", "#10B981", "#FFD700", "#ffffff", "#3B82F6"],
      });
      if (onUnlocked) onUnlocked();
      onClose();
    } catch (err) {
      console.error("Unlock live error:", err);
      alert(err.response?.data?.detail || "Erro ao desbloquear Modo Live.");
    }
  };

  return (
    <div
      data-testid="unlock-modo-live-modal-overlay"
      className="fixed inset-0 z-50 bg-black/90 backdrop-blur-md flex items-center justify-center p-4"
    >
      <div
        data-testid="unlock-modo-live-modal"
        className="bg-gradient-to-b from-[#1E2230] to-[#12141A] border-2 border-[#FF6B00] rounded-3xl w-full max-w-md p-7 text-center relative shadow-[0_0_60px_rgba(255,107,0,0.35)]"
      >
        <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-[#FF6B00] to-[#E05000] flex items-center justify-center text-black mx-auto mb-4 shadow-[0_0_25px_rgba(255,107,0,0.6)] animate-bounce">
          <Unlock className="w-10 h-10 stroke-[2.5]" />
        </div>

        <h2 className="text-2xl sm:text-3xl font-extrabold text-white mb-1 tracking-tight">
          🔓 MODO LIVE DESBLOQUEADO
        </h2>

        <p className="text-sm font-semibold text-[#FF6B00] mb-3">
          Você saiu da preparação.
        </p>

        <p className="text-xs text-gray-300 leading-relaxed mb-6 px-2">
          Sua estrutura completa (Perfil, Página, WhatsApp Business, ZapData e Criativo) está 100% pronta para entrar em operação com tráfego pago.
        </p>

        <button
          data-testid="enter-modo-live-btn"
          onClick={handleUnlock}
          className="w-full py-3.5 rounded-xl bg-gradient-to-r from-[#FF6B00] to-[#FF8533] hover:from-[#FF8533] hover:to-[#FFA066] text-black font-extrabold text-sm uppercase tracking-wider transition-all shadow-[0_0_25px_rgba(255,107,0,0.5)] flex items-center justify-center gap-2"
        >
          <Rocket className="w-5 h-5 fill-black" />
          <span>ENTRAR NO MODO LIVE</span>
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
